import { render, staticRenderFns } from "./AccisureBrokerComissionReportForm.vue?vue&type=template&id=2a10ddf7&scoped=true"
import script from "./AccisureBrokerComissionReportForm.vue?vue&type=script&lang=js"
export * from "./AccisureBrokerComissionReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10ddf7",
  null
  
)

export default component.exports